var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardCardDownwardTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 0.833414C11.9534 0.833414 15.1667 4.04675 15.1667 8.00008C15.1667 11.9534 11.9534 15.1667 8.00008 15.1667C4.04675 15.1667 0.833414 11.9534 0.833414 8.00008C0.833414 4.04675 4.04675 0.833414 8.00008 0.833414ZM8.00008 14.1667C11.4001 14.1667 14.1667 11.4001 14.1667 8.00008C14.1667 4.60008 11.4001 1.83341 8.00008 1.83341C4.60008 1.83341 1.83341 4.60008 1.83341 8.00008C1.83341 11.4001 4.60008 14.1667 8.00008 14.1667Z",
    fill: "#D92D20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.16675C8.27333 5.16675 8.5 5.39341 8.5 5.66675V9.66675C8.5 9.94008 8.27333 10.1667 8 10.1667C7.72667 10.1667 7.5 9.94008 7.5 9.66675V5.66675C7.5 5.39341 7.72667 5.16675 8 5.16675Z",
    fill: "#D92D20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99996 7.83345C6.12662 7.83345 6.25329 7.88012 6.35329 7.98012L7.99996 9.62679L9.64662 7.98012C9.83996 7.78679 10.16 7.78679 10.3533 7.98012C10.5466 8.17345 10.5466 8.49345 10.3533 8.68679L8.35329 10.6868C8.15996 10.8801 7.83996 10.8801 7.64662 10.6868L5.64663 8.68679C5.45329 8.49345 5.45329 8.17345 5.64663 7.98012C5.74662 7.88012 5.87329 7.83345 5.99996 7.83345Z",
    fill: "#D92D20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCardDownwardTickIcon);
export default __webpack_public_path__ + "static/media/dashboard-card-downward-tick-icon.37514d939852d827695879d0c59b6e2e.svg";
export { ForwardRef as ReactComponent };